import { faWavePulse } from "@fortawesome/pro-regular-svg-icons";

import { EmptyState as EmptyStateComponent } from "src/design-system/EmptyState";
import { assertUnreachable } from "src/utils/typeUtils";

type Props = {
  type:
    | "no_version_selected"
    | "no_rows_matching"
    | "timeout"
    | "forbidden"
    | "unknown_error";
};

export const EmptyState: React.FC<Props> = ({ type }) => {
  let title: string = "";
  let description: string = "";

  switch (type) {
    case "no_rows_matching":
      title = "No results found";
      description =
        "Try adjusting the search or filter to find what you are looking for";
      break;
    case "no_version_selected":
      title = "Select a version";
      description = "Select a published version to get started";
      break;
    case "timeout":
      title = "Too many decisions";
      description = "Try adjusting the filters to match fewer decisions";
      break;
    case "forbidden":
      title = "Decision access denied";
      description = "You don't have permission to view these decisions";
      break;
    case "unknown_error":
      title = "Something went wrong";
      description = "We've been notified about it";
      break;
    default:
      assertUnreachable(type);
  }

  return (
    <EmptyStateComponent
      headline={title}
      description={description}
      icon={faWavePulse}
    />
  );
};
